import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeopleAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPeopleAdd"><Path d="M7.50098 6.5C7.50098 4.01472 9.5157 2 12.001 2C14.4863 2 16.501 4.01472 16.501 6.5C16.501 8.98528 14.4863 11 12.001 11C9.5157 11 7.50098 8.98528 7.50098 6.5Z" fill="currentColor"/><Path d="M17.001 14V17H14.001V19H17.001V22H19.001V19H22.001V17H19.001V14H17.001Z" fill="currentColor"/><Path d="M12.0008 21V15H15.0008V12.4767L14.2524 12.2821C13.5408 12.0971 12.7874 12 12.0008 12C7.24298 12 3.91741 15.5211 3.50515 19.9064L3.40234 21H12.0008Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPeopleAdd;
